import { z } from 'zod'
import { stringSchema } from './common'

const menuItemSchema = z.object({
  id: stringSchema.min(1),
  parentId: stringSchema.nullish(),
  position: z.number(),
  title: stringSchema.min(1),
  url: stringSchema.min(1),
  external: z.boolean().default(false),
  restrictedCountries: z.array(z.string()),
})

type MenuItem = z.infer<typeof menuItemSchema> & {
  children?: MenuItem[] | null
}

const menuItemWithChildrenSchema: z.ZodType<MenuItem> = menuItemSchema.extend({
  children: z.lazy(() => z.array(menuItemWithChildrenSchema).nullish()),
})

export const menuSchema = z.array(menuItemWithChildrenSchema)
